// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap; /* keeps mobile responsive */
}

.page-info {
  font-weight: 600;
  font-size: 16px;
  color: #333;
  min-width: 160px;
  text-align: center;
}

.zoom-wrapper {
  transform-origin: center;
  transition: transform 0.2s ease;
}
.zoom-float-controls {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  flex-direction: column;
  gap: 10px;

  background: white;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.zoom-float-controls button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  background: #f5f5f5;
}

.zoom-float-controls button:hover {
  background: #ddd;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top: 5px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".book-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 15px;\n  flex-wrap: wrap; /* keeps mobile responsive */\n}\n\n.page-info {\n  font-weight: 600;\n  font-size: 16px;\n  color: #333;\n  min-width: 160px;\n  text-align: center;\n}\n\n.zoom-wrapper {\n  transform-origin: center;\n  transition: transform 0.2s ease;\n}\n.zoom-float-controls {\n  position: fixed;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  background: white;\n  padding: 10px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n}\n\n.zoom-float-controls button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  background: #f5f5f5;\n}\n\n.zoom-float-controls button:hover {\n  background: #ddd;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #ccc;\n  border-top: 5px solid #fff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
